import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { EFooterStyleInput } from "../../data-types/footer.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { LocalStorageService } from "../../services/local-storage.service";
import { iconsLibrary } from "../../../theme/constants";
import { IAppState } from "../../store/state/app.state";
@Component({
  selector: "cowing-core-coworking-home",
  templateUrl: "./coworking-home.component.html",
  styleUrls: ["./coworking-home.component.scss"],
})
export class CoworkingHomeComponent implements OnInit {
  public EFooterStyleInput = EFooterStyleInput;
  public coworkingId;
  public content: string = null;

  constructor(private _store: Store<IAppState>, private _router: Router) {
    let currentContent: string = "booking";

    _router.events.subscribe((val) => {
      if (this._router.url.includes("home")) currentContent = "home";
      if (this._router.url.includes("spaces")) currentContent = "spaces";
      if (this._router.url.includes("booking")) currentContent = "booking";
      this.content = currentContent;
    });
  }
  ngOnInit() {
    this.coworkingId = LocalStorageService.instance.get(
      EStorageType.ActiveCoworking
    );
  }

  public get getConfirmation() {
    return `${iconsLibrary.confirm}`;
  }
}
